import { render, staticRenderFns } from "./InboxIcon.vue?vue&type=template&id=7a31bc83&scoped=true&"
import script from "./InboxIcon.vue?vue&type=script&lang=ts&"
export * from "./InboxIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a31bc83",
  null
  
)

export default component.exports